import {
  startRegistration,
  startAuthentication,
  browserSupportsWebAuthn
} from '@simplewebauthn/browser'
import { api, setAuthMarker } from './api'

export { browserSupportsWebAuthn }

export const PASSKEY_FLAG_KEY = 'wb-passkey'

export interface Passkey {
  id: number
  createdAt: string
  transports?: string[]
}

export interface PasskeyLoginResult {
  token: string
  userId: number
  email: string
  name: string
}

export async function registerPasskey(): Promise<void> {
  const optionsResponse = await api.post('/auth/passkey/register/options')
  const attestation = await startRegistration({ optionsJSON: optionsResponse.data })
  await api.post('/auth/passkey/register/verify', attestation)
  localStorage.setItem(PASSKEY_FLAG_KEY, '1')
}

export async function loginWithPasskey(): Promise<PasskeyLoginResult> {
  const optionsResponse = await api.post('/auth/passkey/login/options')
  const assertion = await startAuthentication({ optionsJSON: optionsResponse.data })
  const verifyResponse = await api.post<PasskeyLoginResult>('/auth/passkey/login/verify', assertion)
  const { userId, name } = verifyResponse.data
  setAuthMarker(userId, name)
  return verifyResponse.data
}

export async function listPasskeys(): Promise<Passkey[]> {
  const response = await api.get<Passkey[]>('/auth/passkey')
  return response.data
}

export async function deletePasskey(id: number): Promise<void> {
  await api.delete(`/auth/passkey/${id}`)
}
